export enum OnBoardingStep {
    themes = 'themes',
    slides = 'slides',
    slidesAddPopup = 'slidesAddPopup',
    music = 'music',
    payment = 'payment',
}